import axios from 'axios';

export default class SecurityApi {
  constructor(baseUrl, config) {
    this.baseUrl = baseUrl;
    this.config = config;
  }
  //TODO:Could just use the generic method
  postRefreshToken = refreshToken => {
    let outputPromise = new Promise((resolve, reject) => {
      const url = `${this.baseUrl}/token`;
      const data = `grant_type=refresh_token&refresh_token=${encodeURIComponent(
        refreshToken
      )}`;
      axios
        .post(url, data)
        .then(function(response) {
          let token = response.data;
          token ? resolve(token) : reject();
        })
        .catch(error => {
          reject(error);
        });
    });
    return outputPromise;
  };
}



// WEBPACK FOOTER //
// ./src/common/Security/api/SecurityApi.js